import { Stack, styled } from '@ltvco/refresh-lib/theme';

interface ChatTermsContainerProps {
  isAnimating?: boolean;
  animationPhase?: 'center' | 'moving-up' | 'moving-left' | 'header';
  isLanding?: boolean;
}

export const ChatTermsContainer = styled(Stack)<ChatTermsContainerProps>(
  ({ theme, isAnimating, animationPhase, isLanding }) => ({
    flexDirection: 'column',
    gap: theme.spacing(1),
    width: '100%',
    margin: '209px 0 0',
    padding: theme.spacing(2),
    transition: 'opacity 1.2s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
    ...(isAnimating &&
      animationPhase === 'moving-up' && {
        opacity: 0,
        transition: 'opacity 0.2s ease-out',
      }),
    ...(isAnimating &&
      animationPhase === 'moving-left' && {
        opacity: 0,
      }),
    ...(isAnimating &&
      animationPhase === 'header' && {
        opacity: 0,
      }),
    ...(!isLanding && {
      opacity: 0,
      visibility: 'hidden',
      display: 'none',
    }),
    '@media (min-width: 768px)': {
      margin: '110px 0 0 ',
    },
    '@media (min-width: 900px)': {
      margin: '66px auto 0',
      width: '75%',
    },
    '@media (min-width: 375px) and (max-width: 500px)': {
      margin: '160px 0 0',
    },
  })
);
